import {EdgeBilling, EdgeBillingContract} from '.';

function mapInvoice(c: EdgeBillingContract.Invoice): EdgeBilling.Invoice {
  return {
    date: c.issuance_at,
    periodStart: c.period_start,
    periodEnd: c.period_end,
    seats: c.seats,
    total: c.total_period_amount_usd,
  };
}

function mapReport(c: EdgeBillingContract.History): EdgeBilling.History {
  return {
    upcoming: c.upcoming_info ? mapInvoice(c.upcoming_info) : undefined,
    history: c.history,
  };
}

export const edgeBillingMapper = {mapReport};
